import React from 'react';
import * as Icons from "react-icons/fa";
import '../../components/styles.css';

export default function OurProgram() {
    return (
      <div className='container-content-services'
        style={{
          backgroundColor:'gray',
          color:'black',
          border:'20px',
          padding:'20px',
		  	}}
		  >
        <div classNAme='main-content-box-1'  align='center'>
          <p-lg>Our Program </p-lg>
        </div>
        <div className='main-content-box-2'  align='left'>
          <p> <br></br>
            Our affiliate marketing program is purely performance-based. Digital sales agents employ a 
straightforward marketing strategy in which commissions are earned by promoting products or 
services from our partner companies. Agents use unique tracking links to drive traffic to the 
merchant’s website and receive a percentage of the revenue generated from resulting sales or other 
actions, such as sign-ups or downloads. </p>
<p>
  <br></br>
Our program focuses on markets within the United States. 
          </p>
        </div>
        <div className='main-content-box-3' align='center' >
              <p></p>
        </div>
      </div>
    )
  };

  /*

  */